import { socialLinks } from "../../utils/websiteData";
import Logo from "../Logo/Logo";
import "./footer.css";
const Footer = () => {
  return (
    <footer>
      <a href="#home" className="footer-logo">
        <Logo />
      </a>

      <ul className="footer-links">
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>

        <li>
          <a href="#home">Contact</a>
        </li>
      </ul>
      <div className="footer-social">
        {socialLinks.map((link) => {
          return (
            <div key={link.id}>
              <a href={link.url}>{link.icon}</a>
            </div>
          );
        })}
      </div>
      <div className="footer-copyright">
        <small>&copy; Mohamad El Haj Hassan. All rights reserved</small>
      </div>
    </footer>
  );
};
export default Footer;
